export function withdrawPayoutV3(send) {
  return (payoutId, ...args) =>
    send(
      {
        path: '/v3/payouts/{payoutId}',
        pathParameters: { payoutId },
        type: 'delete',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
